module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAMAAADyHTlpAAAANlBMVEUAAAAAM2YAHHEAIncAIHAAHHEAF3EAG3IAGnMAG3IAGnIAGXIAGnIAGnIAGnIAGnIAGnL///9pKRwWAAAAEHRSTlMABQkPEBIiQ0V7w8nLzvf6Mj7HIQAAAAFiS0dEEeK1PboAAABgSURBVDjL7dO9DoAgEAPg8qMCItz7P62RSHQhdDIO15Uv6XUA0Gg+j4uBlD5LMayUxLXvIsfyVxmiey3KfixN6c8zCaQbzGU/kFrU0Mptv6rrtP2xnGyWlIDdrP4+zSAnT7wEszNfOJQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_select.png
// module id = YRv4
// module chunks = 1